const icon = require('vue-svgicon');
icon.register({
    'sign-check': {
        width: 14,
        height: 14,
        viewBox: '0 0 14 14',
        data: `<path pid="0" d="M7 .778L8.385 1.83l1.726-.22.672 1.605 1.605.673-.22 1.726L13.222 7l-1.054 1.385.22 1.726-1.605.673-.672 1.605-1.726-.22L7 13.222 5.615 12.17l-1.727.22-.672-1.605-1.605-.673.22-1.726L.777 7l1.054-1.385-.22-1.726 1.605-.673.672-1.605 1.727.22L7 .778z" _fill="#6737AF"/><path pid="1" d="M9.082 4.407l-.596.623-2.402 2.402-.7-.674-.623-.622-1.218 1.218.622.623 1.296 1.296.597.622.622-.622 3.025-3.025.622-.622-1.245-1.219z" _fill="#fff"/><path pid="2" d="M9.082 4.407l-.596.623-2.402 2.402-.7-.674-.623-.622-1.218 1.218.622.623 1.296 1.296.597.622.622-.622 3.025-3.025.622-.622-1.245-1.219z" _fill="#fff"/>`,
    },
});
